<template>
  <b-card>
    <b-row class="mb-3">
      <b-col sm="6">
        <b-row>
            <b-col sm="6">
                <b-form-group label="Nombre" class="mb-0">
                  <b-form-input
                      type="text"
                      placeholder="Buscar"
                      class="form-control"
                      v-model="search"
                      @keyup.enter="handleSearch"
                  />
                </b-form-group>
            </b-col>
            <b-col sm="6" class="d-flex align-items-end">
                <b-button-group>
                    <b-button
                        variant="primary"
                        @click="handleSearch">
                      <i class="fa fa-search"/>
                      <span class="d-none d-md-inline-block ml-1" v-text="'Buscar'"/>
                    </b-button>
                    <b-button
                        @click="clearFilter">
                      <i class="fa fa-eraser"/>
                      <span class="d-none d-md-inline-block ml-1" v-text="' Limpiar'"/>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
      </b-col>

      <b-col sm="6" class="text-right d-flex align-items-end justify-content-end">
         <b-button variant="info" @click="$emit('create')">
          <i class="fa fa-plus" />
          <span class="d-none d-md-inline-block ml-1" v-text="' Nuevo Tipo'" />
        </b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-table
            responsive
            :items="tableData"
            :fields="columns"
            thead-tr-class="table-active"
            class="mb-2"
            v-loading="loading"
        >
          <!-- Columna nombre -->
          <template v-slot:cell(name)="data">
              {{ data.item.name }}
          </template>

          <template v-slot:cell(code)="data">
             <span class="badge badge-secondary">{{ data.item.code }}</span>
          </template>

          <template v-slot:cell(is_active)="data">
            <b-badge v-if="Number(data.item.is_active) === 1" variant="success">Activo</b-badge>
            <b-badge v-else variant="danger">Inactivo</b-badge>
          </template>

          <template v-slot:cell(actions)="data">
            <el-tooltip content="Editar" placement="top" effect="dark" size="small">
              <b-btn variant="info"
                class="mr-2 mt-2"
                size="sm"
                @click="$emit('edit', data.item.id)">
                <i class="fa fa-edit"/>
              </b-btn>
            </el-tooltip>

            <el-tooltip v-if="Number(data.item.is_active) === 1" content="Inactivar" placement="top" effect="dark" size="small">
              <b-btn
                variant="danger"
                class="mr-2 mt-2"
                size="sm"
                :disabled="togglingId === data.item.id"
                @click="handleToggleStatus(data.item)">
                <i class="fa fa-close"/>
              </b-btn>
            </el-tooltip>

            <el-tooltip v-else content="Activar" placement="top" effect="dark" size="small">
              <b-btn
                variant="success"
                class="mr-2 mt-2"
                size="sm"
                :disabled="togglingId === data.item.id"
                @click="handleToggleStatus(data.item)">
                <i class="fa fa-check"/>
              </b-btn>
            </el-tooltip>

             <!-- Detail button if needed -->
             <!-- <b-btn variant="dark"
                    class="mr-2 mt-2"
                    size="sm"
                    @click="$emit('detail', data.item.id)"
                    title="Ver Detalle">
               <i class="fa fa-eye"/>
             </b-btn> -->
          </template>
        </b-table>

        <el-pagination
            v-if="total > 0"
            v-model="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            class="float-right"
            :page-size.sync="perPage"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next"
            :total="total"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      loading: false,
      togglingId: null,
      tableData: [],
      total: 0,
      columns: [
        {
          key: "id",
          label: "ID",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          key: "name",
          label: "Nombre",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          key: "code",
          label: "Código",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          key: "is_active",
          label: "Estado",
          sortable: true,
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          key: "actions",
          label: "Operaciones",
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
    };
  },
  computed: {
    ...mapState("inventoryTypes", ["listParams"]),
    currentPage: {
      get() {
        return this.listParams.page;
      },
      set(val) {
        this.setListParams({ page: val });
      },
    },
    perPage: {
      get() {
        return this.listParams.perPage;
      },
      set(val) {
        this.setListParams({ perPage: val });
      },
    },
    search: {
      get() {
        return this.listParams.search;
      },
      set(val) {
        this.setListParams({ search: val });
      },
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions("inventoryTypes", ["paginateInventoryType", "toggleInventoryTypeStatus"]),
    ...mapMutations("inventoryTypes", ["setListParams", "resetListParams"]),

    async handleToggleStatus(item) {
      const isActive = Number(item.is_active) === 1;
      const nextStatus = isActive ? 0 : 1;
      const actionText = isActive ? "inactivar" : "activar";

      const confirmResult = await Swal.fire({
        title: `¿Deseas ${actionText} este tipo de reporte?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar",
      });

      if (!confirmResult.isConfirmed) return;

      this.togglingId = item.id;
      const success = await this.toggleInventoryTypeStatus(item.id);
      if (success) {
        this.$set(item, 'is_active', nextStatus);
      }
      this.togglingId = null;
    },

    async fetchData() {
      this.loading = true;
      const response = await this.paginateInventoryType({
          page: this.currentPage,
          per_page: this.perPage,
          search: this.search
      });

      if (response) {
          this.tableData = response.data || [];
          this.total = response.total || 0;
      }

      this.loading = false;
    },

    handleSearch() {
        this.currentPage = 1;
        this.fetchData();
    },

    clearFilter() {
        this.resetListParams();
        this.fetchData();
    },

    handleSizeChange(val) {
        this.perPage = val;
        this.currentPage = 1;
        this.fetchData();
    },

    handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchData();
    }
  },
};
</script>
